export default __webpack_public_path__ + "static/media/turkgo-screenshot-05.9366b8bd.png";